export enum MapExportLegendPlacement {
    Top = "Top",
    Bottom = "Bottom",
    Right = "Right",
    Left = "Left",
    Hidden = "Hidden"
}